import React from 'react';
import Footer from '../component/Footer';

const Urosurgery = () => {
    return (
        <>
            <div className="container">
             
                <div className="text-center my-5">
                    <h1>Uro Surgery</h1>
                </div>

               
                <div className="row">
                    <div className="col-md-12">
                        <p>
                            Uro surgery involves the diagnosis, treatment, and surgical management of disorders affecting
                            the urinary system, including the kidneys, bladder, and urethra. Our expert team handles conditions
                            such as kidney stones, prostate issues, and bladder disorders.
                        </p>
                        <p>
                            We specialize in minimally invasive techniques for various urological conditions, offering
                            treatments such as laparoscopic and robotic surgeries to reduce recovery time and improve outcomes.
                        </p>
                        <p>
                            With advanced medical technology and a dedicated surgical team, we provide personalized care to
                            ensure the best possible treatment and recovery for our patients.
                        </p>
                    </div>
                </div>
            </div>

            
            <Footer />
        </>
    );
}

export default Urosurgery;
